<div id="confirmation">
  <div>
    @if (type != 'win' && type != 'loss') {
    <div class="confirmation-message">
      @if (type == 'booked') { You booked your match } @else { @if (type ==
      'invite-player') { You sent invite request } @else { @if (type ==
      'add-friend') { You sent friend request } } }
    </div>
    <div id="logo-img-div">
      <img
        id="logo-img"
        src="../../assets/reball/reball logo no bg.png"
        alt=""
      />
    </div>
    <div class="confirmation-message">ReBall</div>
    } @else {
    <div id="win-loss-div">
      @if (type == 'win') {
      <span class="msg-span">Congrats</span>
      <img id="confetti-img" src="../../assets/images/confetti.png" alt="" />
      } @else {
      <span class="msg-span"> You'll get them next time </span>
      }
    </div>
    <div id="points-gained">
      <div class="stats-gained">
        @if (type == 'win') { Points gained: {{ pointsGained }} } @else { Points
        lost: {{ pointsGained * -1 }}
        }
      </div>
    </div>
    }
  </div>
</div>
